<template>
  <div>
    <ts-card-wrapper>
      <div class="d-flex justify-content-end">
        <div class="d-flex">
          <ts-input
            v-model="search"
            v-tooltip="$t('expenseCategory.search')"
            :placeholder="$t('search')"
            style="width: 250px;"
            class="inline-block"
          />
        </div>
      </div>
    </ts-card-wrapper>
    <Table
      :columns="columns"
      :data="resources"
      size="small"
      :loading="loading"
      max-height="700"
    >
    </Table>
    <ts-card-wrapper>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'assignedIndex',
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('report/productAddonInfoNotAssign', [
      'resources',
      'pagination'
    ]),
    search: {
      get () {
        return this.$store.state.report.productAddonInfoNotAssign.search
      },
      set (newValue) {
        this.$store.commit(
          'report/productAddonInfoNotAssign/SET_SEARCH',
          newValue
        )
        this.$store.commit(
          'report/productAddonInfoNotAssign/RESET_CURRENT_PAGE'
        )
      }
    },
    columns () {
      return [
        {
          title: this.$t('productAddonInfo.barcode'),
          key: 'barcode',
          sortable: false,
          align: 'center',
          width: 150
        },
        {
          title: this.$t('productAddonInfo.productNameEn'),
          key: 'product_name_en',
          sortable: false
        },
        {
          title: this.$t('productAddonInfo.productNameKh'),
          key: 'product_name_kh',
          sortable: false
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('report/productAddonInfoNotAssign/fetch', {
          ...attributes
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'Product Addon Info',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('report/productAddonInfoNotAssign/RESET_STATE')
    next()
  }
}
</script>
